import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import Slider from 'react-slick';
import Image_File from '../../Image_File';


class SlideClient extends Component {
    constructor(props) {
        super(props);

        this.state = {
           image:{
               children:[
                   {
                       parent:"",
                       "path":"55",
                       "name":"55",
                       "type":"directory",
                       children:[{}]
                   }
               ]
           }
        };

    }
    shouldComponentUpdate() {
        return false;
    }
    componentDidMount() {
        this.setState({
            image:Image_File
        })

    }
    render() {
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay:true
        },
            imgPath = 'https://mordorintelligence.com:81/mordorlabs';

        let      imgTpl  = Image_File.children[0].children.map((image, index) => {
                return (
                <div>
                    <img src={imgPath+"/img/images_clients/"+image.path}
                         data-src={"../../../img/images_clients/"+image.path}
                         className="img-responsive" alt="mordor"/>
                </div>
                )

            }),
                 imgTpl1 = Image_File.children[1].children.map((image, index) => {
                    return (
                        <div>
                            <img src={imgPath+"/img/images_clients/"+image.path}
                                 data-src={"../../../img/images_clients/"+image.path}
                                 className="img-responsive" alt="mordor"/>
                        </div>
                    )

                }),
                 imgTpl2 = Image_File.children[2].children.map((image, index) => {
                    return (
                        <div>
                            <img src={imgPath+"/img/images_clients/"+image.path}
                                 data-src={"../../../img/images_clients/"+image.path}
                                 className="img-responsive" alt="mordor"/>
                        </div>
                    )

                }),
                 imgTpl3 = Image_File.children[3].children.map((image, index) => {
                    return (
                        <div>
                            <img src={imgPath+"/img/images_clients/"+image.path}
                                 data-src={"../../../img/images_clients/"+image.path}
                                 className="img-responsive" alt="mordor"/>
                        </div>
                    )

                }),
                 imgTpl4 = Image_File.children[4].children.map((image, index) => {
                    return (
                        <div>
                            <img src={imgPath+"/img/images_clients/"+image.path}
                                 data-src={"../../../img/images_clients/"+image.path}
                                 className="img-responsive" alt="mordor"/>
                        </div>
                    )

                }),
                 imgTpl5 = Image_File.children[5].children.map((image, index) => {
                    return (
                        <div>
                            <img src={imgPath+"/img/images_clients/"+image.path}
                                 data-src={"../../../img/images_clients/"+image.path}
                                 className="img-responsive" alt="mordor"/>
                        </div>
                    )

                }),
                 imgTpl6 = Image_File.children[6].children.map((image, index) => {
                    return (
                        <div>
                            <img src={imgPath+"/img/images_clients/"+image.path}
                                 data-src={"../../../img/images_clients/"+image.path}
                                 className="img-responsive" alt="mordor"/>
                        </div>
                    )

                }),
                 imgTpl7 = Image_File.children[7].children.map((image, index) => {
                    return (
                        <div>
                            <img src={imgPath+"/img/images_clients/"+image.path}
                                 data-src={"../../../img/images_clients/"+image.path}
                                 className="img-responsive" alt="mordor"/>
                        </div>
                    )

                }),
                 imgTpl8 = Image_File.children[8].children.map((image, index) => {
                    return (
                        <div>
                            <img src={imgPath+"/img/images_clients/"+image.path}
                                 data-src={"../../../img/images_clients/"+image.path}
                                 className="img-responsive" alt="mordor"/>
                        </div>
                    )

                });



        return (

                <section className="logo_slider">
                                <div className="container">
                                    <div className="all_logo abn">
                                        <p>trusted by<br className="hidden-xs" /> 300+ brands</p>
                                        <span><Link to="/clients">View All Clients</Link></span>
                                    </div>
                                    <div className="logo_slide">

                                        <Slider {...settings}>

                                            {imgTpl}
                                            {imgTpl1}
                                            {imgTpl2}
                                            {imgTpl3}
                                            {imgTpl4}
                                            {imgTpl5}
                                            {imgTpl6}
                                            {imgTpl7}
                                            {imgTpl8}



                                        </Slider>


                                    </div>
                                </div>
                            </section>
        );
    }
}

export default SlideClient;


// WEBPACK FOOTER //
// ./src/home/slide-client/slide-client.js